var _this = this;

var throttle = function throttle(func, delay) {
  var timer;
  var startTime = Date.now();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var curTime = Date.now();
    var remaining = delay - (curTime - startTime);
    clearTimeout(timer);

    if (remaining <= 0) {
      func.apply(_this, args);
      startTime = curTime;
    } else {
      timer = window.setTimeout(function () {
        func.apply(_this, args);
        startTime = Date.now();
      }, remaining);
    }
  };
};

export default throttle;